import { ZDate } from '../../../shared/zDate';
export class User {
  _id?: number;
  name?: string;
  email?: string;
  username?: string;
  password?: string;
  profileImg?: {
    name:string,
    imgUrl?:string
  };
  active?: boolean;
  role?: {
    _id:number,
    name?:string
  };
  
  createdBy?: {
    _id:number,
    name?:string
  };
  createdDate?:number;
  createdDateX?:ZDate;
  updatedBy?: {
    _id:number,
    name?:string
  };
  updatedDate?:number;
  updatedDateX?:ZDate;
  deleted?: number;
  deletedBy?: {
    _id:number,
    name?:string
  };
  deletedDate?:number;
  deletedDateX?:ZDate;
}



// WEBPACK FOOTER //
// ./src/app/module/user/shared/user.ts